import TipoDespesa from './TipoDespesa';

export default TipoDespesa;